import React, { useState } from "react";
import { useLeadCapture } from "@/hooks/useLeadCapture";
import ThankYouMessage from "@/components/common/ThankYouMessage";
const TestOurAI = () => {
  const [showThankYou, setShowThankYou] = useState(false);
  const {
    openLeadCapture,
    LeadCaptureModalComponent
  } = useLeadCapture({
    title: "Teste nossa IA",
    description: "Preencha seus dados para testar nossa IA agora mesmo",
    onSuccess: lead => {
      setShowThankYou(true);
    }
  });
  return <section id="teste-ai" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-toctoc-beige/20">
      {LeadCaptureModalComponent}
      
      <div className="container max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-toctoc-black mb-4">
            Transforme suas fotos de imóveis com tecnologia avançada
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experimente nossa IA agora mesmo e veja como podemos transformar suas fotos em imagens profissionais em segundos.
          </p>
        </div>
        
        {showThankYou ? <ThankYouMessage title="Obrigado pelo seu interesse no app mais desejado pelos corretores!" message="Em breve entraremos em contato." buttonText="Voltar para o início" onButtonClick={() => setShowThankYou(false)} /> : <div className="bg-white shadow-xl rounded-2xl overflow-hidden max-w-5xl mx-auto">
            <div className="flex flex-col md:flex-row">
              <div className="w-full md:w-1/2 p-8 md:p-12">
                <h3 className="text-2xl font-bold text-toctoc-black mb-4">Teste o Toc Rápido agora</h3>
                <p className="text-gray-600 mb-6">
                  Nossa IA avançada vai transformar suas fotos de imóveis em imagens profissionais instantaneamente.
                </p>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-full bg-toctoc-blue/10 flex items-center justify-center text-toctoc-blue font-bold mr-3">1</div>
                    <p className="text-gray-700">Edição profissional automatizada</p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-full bg-toctoc-blue/10 flex items-center justify-center text-toctoc-blue font-bold mr-3">2</div>
                    <p className="text-gray-700">Acabamento perfeito em segundos</p>
                  </div>
                  <div className="flex items-center">
                    <div className="w-8 h-8 rounded-full bg-toctoc-blue/10 flex items-center justify-center text-toctoc-blue font-bold mr-3">3</div>
                    <p className="text-gray-700">Resultados que aumentam suas vendas</p>
                  </div>
                </div>
                <button onClick={() => openLeadCapture('Start')} className="mt-8 bg-toctoc-orange hover:bg-toctoc-orange/90 text-white font-semibold py-3 px-8 rounded-full transition-all hover:shadow-lg">
                  Testar Agora
                </button>
              </div>
              <div className="w-full md:w-1/2 bg-gradient-to-br from-toctoc-blue to-blue-800 p-8 md:p-12 text-white flex items-center">
                <div>
                  <h3 className="text-2xl font-bold mb-4">Benefícios exclusivos</h3>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-toctoc-orange mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Resultados profissionais imediatos</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-toctoc-orange mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Economia de tempo significativa</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-toctoc-orange mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Fotos mais atraentes para seus clientes</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-toctoc-orange mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Tecnologia exclusiva Toc Toc</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-5 w-5 text-toctoc-orange mr-2 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Suporte especializado para corretores</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </section>;
};
export default TestOurAI;